import React, { Component } from 'react';
import PropTypes from 'prop-types';

var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

function index(resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index]);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;
    if (length !== keyList(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    }

    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  return a !== a && b !== b;
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function Cell(_ref) {
  var x = _ref.x,
      y = _ref.y,
      value = _ref.value,
      height = _ref.height,
      children = _ref.children,
      rest = objectWithoutProperties(_ref, ['x', 'y', 'value', 'height', 'children']);
  return React.createElement('div', rest, React.createElement('div', {
    style: {
      paddingTop: height / 3.7 + 'px'
    }
  }, children));
}

Cell.propTypes = {
  height: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  value: PropTypes.any.isRequired
};
Cell.defaultProps = {};

function YLabel(_ref) {
  var index = _ref.index,
      height = _ref.height,
      style = _ref.style,
      value = _ref.value;
  return React.createElement('div', {
    style: _extends({
      textAlign: 'center',
      paddingRight: '5px',
      paddingTop: height / 3.7 + 'px'
    }, style)
  }, value);
}

YLabel.propTypes = {
  index: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
YLabel.defaultProps = {
  style: {}
};

function XLabel(_ref) {
  var index = _ref.index,
      height = _ref.height,
      squares = _ref.squares,
      style = _ref.style,
      value = _ref.value;
  return React.createElement('div', {
    style: _extends({
      flex: squares ? 'none' : 1,
      textAlign: 'center',
      width: squares ? height + 1 + 'px' : 'undefined'
    }, style)
  }, value);
}

XLabel.propTypes = {
  height: PropTypes.number,
  index: PropTypes.number,
  squares: PropTypes.bool,
  style: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
XLabel.defaultProps = {
  style: {}
};
var components = {
  Cell: Cell,
  CellContent: function CellContent() {
    return null;
  },
  YLabel: YLabel,
  XLabel: XLabel
};

var defaultComponents = function defaultComponents(customComponents) {
  return _extends({}, components, customComponents);
};

var HeatMap = function (_Component) {
  inherits(HeatMap, _Component);

  function HeatMap(props) {
    classCallCheck(this, HeatMap);

    var _this = possibleConstructorReturn(this, (HeatMap.__proto__ || Object.getPrototypeOf(HeatMap)).call(this, props));

    _this.cacheComponents = function (components$$1) {
      _this.components = defaultComponents(components$$1);
    };

    _this.cacheComponents = index(_this.cacheComponents, fastDeepEqual).bind(_this);

    _this.cacheComponents(props.components);

    return _this;
  }

  createClass(HeatMap, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.cacheComponents(nextProps.components);
    }
  }, {
    key: 'renderGrid',
    value: function renderGrid() {
      var _props = this.props,
          background = _props.background,
          cellStyle = _props.cellStyle,
          data = _props.data,
          getValue = _props.getValue,
          height = _props.height,
          onClick = _props.onClick,
          squares = _props.squares,
          xLabels = _props.xLabels,
          yLabels = _props.yLabels,
          xLabelWidth = _props.xLabelWidth,
          unit = _props.unit;
      var _components = this.components,
          Cell = _components.Cell,
          CellContent = _components.CellContent,
          YLabel = _components.YLabel;
      var cursor = onClick !== undefined ? 'pointer' : null;
      var values = data.reduce(function (i, o) {
        return [].concat(toConsumableArray(o), toConsumableArray(i));
      }, []).map(getValue);
      var max = Math.max.apply(Math, toConsumableArray(values));
      var min = Math.min.apply(Math, toConsumableArray(values));
      return React.createElement('div', null, yLabels.map(function (y, yi) {
        return React.createElement('div', {
          key: yi,
          style: {
            display: 'flex'
          }
        }, React.createElement('div', {
          style: {
            flex: '0 0 ' + xLabelWidth + 'px'
          }
        }, YLabel && React.createElement(YLabel, {
          value: y,
          index: yi,
          height: height
        })), xLabels.map(function (x, xi) {
          var value = getValue(data[yi][xi]);

          var style = _extends({
            cursor: cursor,
            margin: '1px 1px 0 0',
            height: height,
            width: squares ? height + 'px' : undefined,
            flex: squares ? 'none' : 1,
            textAlign: 'center'
          }, cellStyle(background, value, min, max, data, xi, yi));

          var title = (value || value === 0) && value + ' ' + unit;
          return React.createElement(Cell, {
            key: xi + '_' + yi,
            x: xi,
            y: yi,
            value: value,
            onClick: onClick ? function () {
              return onClick(xi, yi);
            } : undefined,
            title: title,
            style: style,
            height: height
          }, React.createElement(CellContent, {
            value: value
          }));
        }));
      }));
    }
  }, {
    key: 'renderXLabels',
    value: function renderXLabels() {
      var _props2 = this.props,
          xLabels = _props2.xLabels,
          height = _props2.height,
          xLabelWidth = _props2.xLabelWidth,
          squares = _props2.squares;
      var XLabel = this.components.XLabel;
      if (!XLabel) return null;
      return React.createElement('div', {
        style: {
          display: 'flex'
        }
      }, React.createElement('div', {
        style: {
          flex: '0 0 ' + xLabelWidth + 'px'
        }
      }), xLabels.map(function (value, i) {
        return React.createElement(XLabel, {
          key: i,
          index: i,
          value: value,
          squares: squares,
          height: height
        });
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var xLabelsLocation = this.props.xLabelsLocation;
      return React.createElement('div', null, xLabelsLocation === 'top' && this.renderXLabels(), this.renderGrid(), xLabelsLocation === 'bottom' && this.renderXLabels());
    }
  }]);
  return HeatMap;
}(Component);

HeatMap.propTypes = {
  components: PropTypes.object,
  getValue: PropTypes.func,
  xLabels: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])).isRequired,
  yLabels: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])).isRequired,
  data: PropTypes.array.isRequired,
  background: PropTypes.string,
  height: PropTypes.number,
  xLabelWidth: PropTypes.number,
  xLabelsLocation: PropTypes.oneOf(['top', 'bottom']),
  unit: PropTypes.string,
  onClick: PropTypes.func,
  squares: PropTypes.bool,
  cellStyle: PropTypes.func
};
HeatMap.defaultProps = {
  cellStyle: function cellStyle(background, value, min, max) {
    return {
      background: background,
      opacity: (value - min) / (max - min) || 0
    };
  },
  component: {},
  getValue: function getValue(value) {
    return value;
  },
  background: '#239a3b',
  height: 30,
  xLabelWidth: 60,
  xLabelsLocation: 'top',
  onClick: undefined,
  squares: false,
  unit: ''
};
export default HeatMap;
export { components };